import Pagination from "@material-ui/lab/Pagination";
import {
  Badge,
  DatePicker,
  Form,
  Input,
  Space,
  Select,
  InputNumber,
  Tabs,
} from "antd";
import _ from "lodash";
import React, { Suspense, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import ActionEditDelete from "../../../components/ActionEditDelete";
import CustomButton from "../../../components/CustomButton";
import { useSubheader } from "../../../_metronic/layout";
import { Card, CardBody } from "../../../_metronic/_partials/controls";
import moment from "moment";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  actionGetListHistorySwapXAU,
  actionGetListSellXAUTele,
} from "../../../redux/transaction/actions";
import {
  _convertHash,
  formatCoin,
  formatCoinID,
  formatMoney,
  formatNumber,
  formatXAU,
} from "../../lib/common";
import { CaretDownOutlined } from "@ant-design/icons";
import * as TYPE from "../../lib/contrant";
import DetailSwapXAU from "./DetailSwapXAU";

const { RangePicker } = DatePicker;
const formRef = React.createRef();
function ListSellXAU(props) {
  const [typeApp, setTypeApp] = useState("app");
  const suhbeader = useSubheader();
  const [visibleSearch, setVisibleSearch] = useState(false);
  const [visible, setVisible] = useState(false);
  const [checkbox, setCheckbox] = useState([]);
  const [visibleModalDetail, setVisibleModalDetail] = useState(false);
  const [recordModal, setRecordModal] = useState(null);
  const [filterModal, setFilterModal] = useState(null);
  const [date, setDate] = useState([null, null]);

  const { intl } = props;
  suhbeader.setTitle(intl.formatMessage({ id: "SIDEBAR.LIST_SELL_XAU" }));
  const dispatch = useDispatch();
  const { dataSwapXAU, listUserLoginPermission, dataSellXAUTele } = useSelector(
    (state) => ({
      dataSwapXAU: state.transactionReducer.dataSwapXAU,
      listUserLoginPermission: state.authReducer.listUserLoginPermission,
      dataSellXAUTele: state.transactionReducer.dataSellXAUTele,
    }),
    shallowEqual
  );

  const [totalUSDBuy, setTotalUSDBuy] = useState(dataSwapXAU.sumUSDBuy || 0);
  const [totalTONBuy, setTotalTONBuy] = useState(
    dataSellXAUTele.sumTONBuy || 0
  );
  const [totalXAUBuy, setTotalXAUBuy] = useState(dataSwapXAU.sumXAUBuy || 0);
  const [totalXAUSell, setTotalXAUSell] = useState(
    dataSellXAUTele.sumXAUSell || 0
  );
  useEffect(() => {
    (async () => {
      // if (listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) {
      //     let swapUSDXAU = await dispatch(actionGetListHistorySwapXAU({ page: 1, type: 'swap_USD_XAU' }));
      //     setTotalUSDBuy(swapUSDXAU.sumUSDBuy)
      //     setTotalUSDSell(swapUSDXAU.sumUSDSell)
      //     setTotalXAUBuy(swapUSDXAU.sumXAUBuy)
      //     setTotalXAUSell(swapUSDXAU.sumXAUSell)
      // } else {
      let dataReq = await dispatch(
        actionGetListHistorySwapXAU({ page: 1, type: "swap_XAU_USDT" })
      );
      let dataTele = await dispatch(
        actionGetListSellXAUTele({ page: 1, type: "withdrawal" })
      );
      setTotalUSDBuy(dataReq.sumUSDBuy);
      setTotalTONBuy(dataTele.sumTONBuy);
      setTotalXAUBuy(dataReq.sumXAUBuy);
      setTotalXAUSell(dataTele.sumXAUSell);
      // }
    })();
  }, []);

  const onChangePage = async (_, page) => {
    let {
      user_name_source,
      user_name_destination,
      transactionID,
      email,
      mobile,
      type,
      start,
      end,
      start_usd,
      end_usd,
      start_xau,
      end_xau,
      vip,
      type_user
    } = formRef.current.getFieldsValue();
    let filter = {};
    if (email) filter.email = email.trim();
    if (type) {
      filter.type = type;
    }
    if (start) {
      filter.start = start;
    }
    if (end) {
      filter.end = end;
    }
    if (start_usd) {
      filter.start_usd = start_usd;
    }
    if (end_usd) {
      filter.end_usd = end_usd;
    }
    if (start_xau) {
      filter.start_xau = start_xau;
    }
    if (end_xau) {
      filter.end_xau = end_xau;
    }
    if (mobile) filter.mobile = mobile.trim();
    if (date && date.length > 0 && date[0]) {
      filter.date = [
        moment(date[0]).format("YYYY/MM/DD"),
        moment(date[1]).format("YYYY/MM/DD"),
      ];
    }
    await dispatch(
      actionGetListHistorySwapXAU({
        ...filter,
        page,
        type: "swap_XAU_USDT",
        user_name_source: user_name_source ? user_name_source.trim() : "",
        transactionID: transactionID ? transactionID.trim() : "",
        user_name_destination: user_name_destination
          ? user_name_destination.trim()
          : "",
        vip: vip,
        type_user: type_user
      })
    );
    await dispatch(
      actionGetListSellXAUTele({
        ...filter,
        page,
        type: "withdrawal",
        user_name_source: user_name_source ? user_name_source.trim() : "",
        transactionID: transactionID ? transactionID.trim() : "",
        user_name_destination: user_name_destination
          ? user_name_destination.trim()
          : "",
          vip: vip,
          type_user: type_user
      })
    );
  };
  const onChangeDateRange = async (e) => {
    let {
      user_name_source,
      email_source,
      mobile_source,
      user_name_destination,
      transactionID,
      email,
      mobile,
      type,
      start,
      end,
      start_usd,
      end_usd,
      start_xau,
      end_xau,
      vip,
      type_user
    } = formRef.current.getFieldsValue();
    let data_filter = {};
    if (type) {
      data_filter.type = type;
    }
    if (start) {
      data_filter.start = start;
    }
    if (start_usd) {
      data_filter.start_usd = start_usd;
    }
    if (end_usd) {
      data_filter.end_usd = end_usd;
    }
    if (start_xau) {
      data_filter.start_xau = start_xau;
    }
    if (end_xau) {
      data_filter.end_xau = end_xau;
    }
    if (end) {
      data_filter.end = end;
    }
    if (email) data_filter.email = email.trim();
    if (mobile) data_filter.mobile = mobile.trim();
    if (email_source) data_filter.email_source = email_source.trim();
    if (mobile_source) data_filter.mobile_source = mobile_source.trim();
    if (e && e.length > 1) {
      let dataReq = await dispatch(
        actionGetListHistorySwapXAU({
          date: [
            moment(e[0]).format("YYYY/MM/DD"),
            moment(e[1]).format("YYYY/MM/DD"),
          ],
          page: 1,
          type: "swap_XAU_USDT",
          user_name_source: user_name_source ? user_name_source.trim() : "",
          transactionID: transactionID ? transactionID.trim() : "",
          user_name_destination: user_name_destination
            ? user_name_destination.trim()
            : "",
            vip: vip,
            type_user: type_user,
          ...data_filter,
        })
      );
      let dataTele = await dispatch(
        actionGetListSellXAUTele({
          date: [
            moment(e[0]).format("YYYY/MM/DD"),
            moment(e[1]).format("YYYY/MM/DD"),
          ],
          page: 1,
          user_name_source: user_name_source ? user_name_source.trim() : "",
          transactionID: transactionID ? transactionID.trim() : "",
          user_name_destination: user_name_destination
            ? user_name_destination.trim()
            : "",
            vip: vip,
            type_user: type_user,
          ...data_filter,
        })
      );
      setTotalUSDBuy(dataReq.sumUSDBuy);
      // setTotalUSDSell(dataReq.sumUSDSell);
      setTotalXAUBuy(dataReq.sumXAUBuy);
      setTotalXAUSell(dataTele.sumXAUSell);
      setTotalTONBuy(dataTele.sumTONBuy)
      setDate(e);
    } else {
      let dataReq = await dispatch(
        actionGetListHistorySwapXAU({
          page: 1,
          type: "swap_XAU_USDT",
          user_name_source: user_name_source ? user_name_source.trim() : "",
          transactionID: transactionID ? transactionID.trim() : "",
          user_name_destination: user_name_destination
            ? user_name_destination.trim()
            : "",
            vip: vip,
            type_user: type_user,
          ...data_filter,
        })
      );
      let dataTele = await dispatch(
        actionGetListSellXAUTele({
          page: 1,
          user_name_source: user_name_source ? user_name_source.trim() : "",
          transactionID: transactionID ? transactionID.trim() : "",
          user_name_destination: user_name_destination
            ? user_name_destination.trim()
            : "",
            vip: vip,
            type_user: type_user,
          ...data_filter,
        })
      );
      setTotalUSDBuy(dataReq.sumUSDBuy);
      // setTotalUSDSell(dataReq.sumUSDSell);
      setTotalXAUBuy(dataReq.sumXAUBuy);
      setTotalXAUSell(dataTele.sumXAUSell);
      setTotalTONBuy(dataTele.sumTONBuy);
    }
  };

  const onSearchDelayed = _.debounce(() => onSearch(), 100);
  const onSearch = async () => {
    let {
      user_name_source,
      email_source,
      mobile_source,
      user_name_destination,
      transactionID,
      email,
      mobile,
      type,
      start,
      end,
      start_usd,
      end_usd,
      start_xau,
      end_xau,
      type_user,
      vip
    } = formRef.current.getFieldsValue();
    setVisibleSearch(true);
    let data_filter = {
      user_name_source: user_name_source ? user_name_source.trim() : "",
      transactionID: transactionID ? transactionID.trim() : "",
      user_name_destination: user_name_destination
        ? user_name_destination.trim()
        : "",
      vip: vip,
      type_user: type_user
    };
    if (date[0] && date[1]) {
      data_filter.date = [
        moment(date[0]).format("YYYY/MM/DD"),
        moment(date[1]).format("YYYY/MM/DD"),
      ];
    }
    if (type) {
      data_filter.type = type;
    }
    if (start) {
      data_filter.start = start;
    }
    if (start_usd) {
      data_filter.start_usd = start_usd;
    }
    if (end_usd) {
      data_filter.end_usd = end_usd;
    }
    if (start_xau) {
      data_filter.start_xau = start_xau;
    }
    if (end_xau) {
      data_filter.end_xau = end_xau;
    }
    if (end) {
      data_filter.end = end;
    }
    if (type_user || type_user == '0')
      data_filter.type_user = type_user
    if (email) data_filter.email = email.trim();
    if (mobile) data_filter.mobile = mobile.trim();
    if (email_source) data_filter.email_source = email_source.trim();
    if (mobile_source) data_filter.mobile_source = mobile_source.trim();
    let dataReq = await dispatch(
      actionGetListHistorySwapXAU({ type: "swap_XAU_USDT", ...data_filter })
    );
    let dataTele = await dispatch(
      actionGetListSellXAUTele({ type: "withdrawal", ...data_filter })
    );
    setTotalUSDBuy(dataReq.sumUSDBuy);
    // setTotalUSDSell(dataReq.sumUSDSell);
    setTotalXAUBuy(dataReq.sumXAUBuy);
    setTotalXAUSell(dataTele.sumXAUSell);
    setTotalTONBuy(dataTele.sumTONBuy);
    setVisible(false);
  };
  const renderStatus = (status) => {
    switch (status) {
      case 0: {
        return <Badge status="warning" text="Chờ" />;
      }
      case 1: {
        return <Badge status="processing" text="Thành công" />;
      }
      case 2: {
        return <Badge status="success" text="Hoàn thành" />;
      }
      case -1: {
        return <Badge status="error" text="Ngừng giao dịch" />;
      }
      default:
        break;
    }
  };
  const closeDetail = () => {
    setRecordModal(null);
    setFilterModal(null);
    setVisibleModalDetail(false);
  };
  const onOpenModal = (dataEdit) => {
    if (!dataEdit) setRecordModal(null);
    else setRecordModal(dataEdit);

    setFilterModal({
      name: dataSwapXAU?.row?.user?.name,
      page: dataSwapXAU?.paging?.page,
    });
    setVisibleModalDetail(true);
  };

  const renderAgency = (level) => {
    switch (level) {
      case 1:
        return "Đại sứ kinh doanh";
      case 2:
        return "Nhượng quyền trực tuyến";
    }
    return "Người dùng";
  };

  const renderBodyTable = () => {
    return dataSwapXAU?.rows?.length > 0 ? (
      dataSwapXAU.rows.map((it, idx) => {
        return (
          <tr key={`renderBodyTable_${it.id || idx}`}>
            <td className="tr-center">
              {(dataSwapXAU?.paging?.page - 1) * dataSwapXAU?.paging?.limit +
                idx +
                1}
            </td>
            <td className="tr-center maxw--200">{it?.transaction_id}</td>
            <td className="tr-center maxw--300">
              {it?.user?.fullname || "--"}
            </td>
            <td className="tr-center maxw--200">{it?.user.level}</td>
            <td className="tr-center maxw--200">
              {renderAgency(it?.user?.agency?.level) || 0}
            </td>
            <td className="tr-center maxw--200">{"USDT"}</td>
            <td className="tr-center maxw--300">
              {it.source_coin_id == 5
                ? formatCoin(it?.amount_coin_source, 5)
                : formatCoin(it?.amount_coin_destination, 5)}
            </td>
            <td className="tr-center maxw--300">
              {/* {`1 XAU = ${formatMoney(it?.exchange_rate || 0)} USD`} */}
              {`1 XAUT = ${formatXAU(it?.exchange_rate || 0)} USDT`}
            </td>
            <td className="tr-center maxw--300">
              {it.source_coin_id == 5
                ? formatCoin(it?.amount_coin_destination, 4)
                : formatCoin(it?.amount_coin_source, 4) || 0}
            </td>
            <td className="tr-center maxw--300">
              {it?.createdAt
                ? moment(it?.createdAt).format("DD/MM/YYYY HH:mm:ss")
                : "Không xác định"}
            </td>
            <td className="tr-center maxw--300">{renderStatus(it?.status)}</td>
            <td className="tr-center maxw--300">
              <ActionEditDelete
                OverlayTrigger={true}
                onclickView={() => onOpenModal(it)}
                hideDelete={true}
                hideEdit={true}
              />
            </td>
          </tr>
        );
      })
    ) : (
      <tr>
        <td className="tr-center" colSpan={12}>
          Không có dữ liệu hiển thị
        </td>
      </tr>
    );
  };
  const renderBodyTeleTable = () => {
    return dataSellXAUTele?.rows?.length > 0 ? (
      dataSellXAUTele.rows.map((it, idx) => {
        return (
          <tr key={`renderBodyTable_${it.id || idx}`}>
            <td className="tr-center">
              {(dataSellXAUTele?.paging?.page - 1) *
                dataSellXAUTele?.paging?.limit +
                idx +
                1}
            </td>
            {/* <td className="tr-center maxw--200">
                            {it?.sale?.fullname || ""}
                        </td> */}
            <td className="tr-center maxw--200">{it?.comment}</td>
            <td className="tr-center maxw--300">
              {it?.user?.fullname || "--"}
            </td>
            <td className="tr-center maxw--300">
              <a href={`https://tonviewer.com/transaction/${it?.tx_hash}`} target="_blank">
                {_convertHash(it?.tx_hash)}
              </a>
            </td>
            <td className="tr-center maxw--200">{it?.user?.level || 0}</td>
            <td className="tr-center maxw--200">
              {renderAgency(it?.user?.agency?.level) || "--"}
            </td>
            <td className="tr-center maxw--200">{"TON"}</td>
            <td className="tr-center maxw--300">
                {/* {it?.amount_receive_coin == null ? `${formatCoin((it?.amount / it?.price), 5)}` : `${_convertValue(it?.amount_receive_coin)}`} */}
                {`${_convertValue(it?.amount_receive_coin)}`}
            </td>
            {/* <td className="tr-center maxw--300">
                            {`1 HNG = ${formatMoney(it?.exchange_rate || 0)} VNDC`}
                        </td> */}
            <td className="tr-center maxw--300">{`1 XAUT = ${formatCoin(
              it?.price,
              3
            )} TON`}</td>
            <td className="tr-center maxw--300">{`${formatCoin(
              it?.amount,
              3
            )}`}</td>
            <td className="tr-center maxw--300">
              {it?.createdAt
                ? moment(it?.createdAt).format("DD/MM/YYYY HH:mm:ss")
                : "Không xác định"}
            </td>
            <td className="tr-center maxw--300">{renderStatus(it?.status)}</td>
            <td className="tr-center maxw--300">
              {/* <ActionEditDelete
                                OverlayTrigger={true}
                                onclickView={() => onOpenModal(it)}
                                hideDelete={true}
                                hideEdit={true}
                                // hideEdit={listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ? false : true}
                                onclickEdit={() => openModalSale(it)}
                            /> */}
              <ActionEditDelete
                OverlayTrigger={true}
                onclickView={() => onOpenModal(it)}
                hideDelete={true}
                hideEdit={true}
              />
            </td>
          </tr>
        );
      })
    ) : (
      <tr>
        <td className="tr-center" colSpan={12}>
          Không có dữ liệu hiển thị
        </td>
      </tr>
    );
  };

  const onClearSearch = async () => {
    formRef.current.setFieldsValue({
      user_name_source: undefined,
      user_name_destination: undefined,
      transactionID: undefined,
      email_source: undefined,
      mobile_source: undefined,
      mobile: undefined,
      email: undefined,
      picker: undefined,
      start_usd: undefined,
      end_usd: undefined,
      start_xau: undefined,
      end_xau: undefined,
      type: "",
      vip: undefined,
      type_user: ""
    });
    setCheckbox([]);
    setDate([null, null]);
    setVisibleSearch(false);

    // if (listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) {
    //     let swapUSDXAU = await dispatch(actionGetListHistorySwapXAU({ page: 1, type: 'swap_USD_XAU' }));
    //     setTotalUSDBuy(swapUSDXAU.sumUSDBuy)
    //     setTotalUSDSell(swapUSDXAU.sumUSDSell)
    //     setTotalXAUBuy(swapUSDXAU.sumXAUBuy)
    //     setTotalXAUSell(swapUSDXAU.sumXAUSell)
    // } else {
    //     let dataReq = await dispatch(actionGetListHistorySwapXAU({ page: 1 }));
    //     setTotalUSDBuy(dataReq.sumUSDBuy)
    //     setTotalUSDSell(dataReq.sumUSDSell)
    //     setTotalXAUBuy(dataReq.sumXAUBuy)
    //     setTotalXAUSell(dataReq.sumXAUSell)
    // }
    let dataReq = await dispatch(actionGetListHistorySwapXAU({ page: 1, type: 'swap_XAU_USDT' }));
    let dataTele = await dispatch(actionGetListSellXAUTele({ page: 1, type: 'withdrawal' }));
    setTotalUSDBuy(dataReq.sumUSDBuy);
    // setTotalUSDSell(dataReq.sumUSDSell);
    setTotalXAUBuy(dataReq.sumXAUBuy);
    setTotalXAUSell(dataTele.sumXAUSell);
    setTotalTONBuy(dataTele.sumTONBuy)
  };
  const onExportDelayed = async () => {
    let {
      user_name_source,
      email_source,
      mobile_source,
      user_name_destination,
      transactionID,
      email,
      mobile,
      type,
      start,
      vip,
      end,
      start_usd,
      end_usd,
      start_xau,
      end_xau,
    } = formRef.current.getFieldsValue();
    setVisibleSearch(true);

    const url = typeApp == 'app' ? new URL(`${process.env.REACT_APP_API_URL}/admin/exportExcel/list-swap-xau`) : new URL(`${process.env.REACT_APP_API_URL}/admin/exportExcel/list-swap-xau-sell-tele`);
    const accessToken = localStorage.getItem("token");
    url.searchParams.append("token", accessToken);
    let data_filter = {
      user_name_source: user_name_source ? user_name_source.trim() : "",
      transactionID: transactionID ? transactionID.trim() : "",
      user_name_destination: user_name_destination
        ? user_name_destination.trim()
        : "",
      type: typeApp == 'app' ? 'swap_USDT_XAU' : ''
    };
    if (date[0] && date[1]) {
      data_filter.date = [
        moment(date[0]).format("YYYY/MM/DD"),
        moment(date[1]).format("YYYY/MM/DD"),
      ];
    }
    if (type) {
      data_filter.type = type;
    }
    if (start_usd) {
      data_filter.start_usd = start_usd;
    }
    if (end_usd) {
      data_filter.end_usd = end_usd;
    }
    if (start_xau) {
      data_filter.start_xau = start_xau;
    }
    if (end_xau) {
      data_filter.end_xau = end_xau;
    }
    if (end) {
      data_filter.end = end;
    }
    if (vip) {
      data_filter.vip = vip;
    }
    if (email) data_filter.email = email.trim();
    if (mobile) data_filter.mobile = mobile.trim();
    if (email_source) data_filter.email_source = email_source.trim();
    if (mobile_source) data_filter.mobile_source = mobile_source.trim();
    Object.keys(data_filter).forEach((key) => {
      url.searchParams.append(key, data_filter[key]);
    });
    window.open(url);
    // setVisibleSearch(false)
    // onClearSearch()
  };

  const enterKeyPressed = (event) => {
    if (event.keyCode == 13) {
      onSearch();
    }
  };

  const _convertValue = (value) => {
    const strValue = `${value}`;
    const arr = strValue.split(".");
    let decimalPart = arr[1] ? arr[1].slice(0, 5) : "";
    decimalPart = decimalPart.replace(/0+$/, "");
    const result = decimalPart ? `${arr[0]},${decimalPart}` : `${arr[0]}`;

    return result;
  };

  const listSwapXAUApp = () => {
    return (
      <>
        <div className="trongCustomTableCtn2">
          <table className="customTable">
            <tr className="bg-E6F8FD">
              <th className="tr-center">STT</th>
              <th className="tr-center">Mã giao dịch</th>
              <th className="tr-center">Khách hàng</th>
              <th className="tr-center">Hạng VIP</th>
              <th className="tr-center">Nhóm người dùng</th>
              <th className="tr-center">Tài sản nhận</th>
              <th className="tr-center">Số lượng (XAUT)</th>
              <th className="tr-center">Tỉ giá</th>
              <th className="tr-center">Số tiền</th>
              <th className="tr-center">Thời gian</th>
              <th className="tr-center">Trạng thái</th>
              <th className="tr-center">Thao tác</th>
            </tr>
            {renderBodyTable()}
          </table>
        </div>
      </>
    );
  };

  const listSwapXAUTeleApp = () => {
    return (
      <>
        <div className="trongCustomTableCtn2">
          <table className="customTable">
            <tr className="bg-E6F8FD">
              <th className="tr-center">STT</th>
              <th className="tr-center">Mã giao dịch</th>
              <th className="tr-center">Khách hàng</th>
              <th className="tr-center">Tx Hash</th>
              <th className="tr-center">Hạng VIP</th>
              <th className="tr-center">Nhóm người dùng</th>
              <th className="tr-center">Tài sản nhận</th>
              <th className="tr-center">Số lượng (XAUT)</th>
              <th className="tr-center">Tỉ giá</th>
              <th className="tr-center">Số tiền</th>
              <th className="tr-center">Thời gian</th>
              <th className="tr-center">Trạng thái</th>
              <th className="tr-center">Thao tác</th>
            </tr>
            {renderBodyTeleTable()}
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardBody>
          <Form className="width100" ref={formRef}>
            <div className="layout-form-header row">
              <div className="col-sm-3 mb--16">
                <div className="customLabel">Mã giao dịch{` `}</div>
                <Form.Item className="name" name="transactionID">
                  <Input
                    onKeyDown={enterKeyPressed}
                    className="customInput width100"
                    placeholder="Nhập mã giao dịch"
                  />
                </Form.Item>
              </div>

              <div className="col-sm-3 mb--16">
                <div className="customLabel">Tên khách hàng{` `}</div>
                <Form.Item className="name" name="user_name_source">
                  <Input
                    onKeyDown={enterKeyPressed}
                    className="customInput width100"
                    placeholder="Nhập tên khách hàng"
                  />
                </Form.Item>
              </div>
              <div className="col-sm-3 mb--16">
                <div className="customLabel">Email{` `}</div>
                <Form.Item className="email" name="email_source">
                  <Input
                    onKeyDown={enterKeyPressed}
                    className="customInput width100"
                    placeholder="Nhập email"
                  />
                </Form.Item>
              </div>
              <div className="col-sm-3 mb--16">
                <div className="customLabel">SĐT{` `}</div>
                <Form.Item className="mobile" name="mobile_source">
                  <Input
                    onKeyDown={enterKeyPressed}
                    className="customInput width100"
                    placeholder="Nhập số điện thoại"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="layout-form-header row">
              <div className="col-sm-3 mb--16">
                <div className="customLabel">Lọc theo thời gian{` `}</div>
                <Space className="customSpace">
                  <Form.Item name="picker">
                    <RangePicker
                      allowClear
                      onChange={(e) => onChangeDateRange(e)}
                      placeholder={["Từ ngày", "Đến ngày"]}
                      className="customDate"
                    />
                  </Form.Item>
                </Space>
              </div>
              <div className="col-sm-3 mb--16">
                <div className="customLabel">Hạng VIP {` `}</div>
                <Form.Item className="name" name="vip">
                  <Select
                    placeholder="Chọn hạng VIP"
                    // defaultValue={""}
                    className="trongCustomSelect2"
                    mode="multiple"
                  >
                    {/* <Select.Option value={""}>Tất cả</Select.Option> */}
                    <Select.Option value={"0"}>Cấp 0</Select.Option>
                    <Select.Option value={"1"}>Cấp 1</Select.Option>
                    <Select.Option value={"2"}>Cấp 2</Select.Option>
                    <Select.Option value={"3"}>Cấp 3</Select.Option>
                    <Select.Option value={"4"}>Cấp 4</Select.Option>
                    <Select.Option value={"5"}>Cấp 5</Select.Option>
                    <Select.Option value={"6"}>Cấp 6</Select.Option>
                    <Select.Option value={"7"}>Cấp 7</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="col-sm-3 mb--16">
                <div className="customLabel">Nhóm người dùng{` `}</div>
                <Form.Item className="name" name="type_user">
                  <Select
                    placeholder="Chọn nhóm người dùng"
                    className="customSelect"
                    suffixIcon={<CaretDownOutlined />}
                    defaultValue={""}
                  >
                    <Select.Option value={""}>Tất cả</Select.Option>
                    <Select.Option value={0}>Người dùng</Select.Option>
                    <Select.Option value={1}>Đại sứ kinh doanh</Select.Option>
                    <Select.Option value={2}>
                      Nhượng quyền trực tuyến
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div className="mb--20 row-end">
              <CustomButton
                className="mr--10"
                title="Tìm kiếm"
                btnBgColor="#3699ff"
                btnColor="#ffffff"
                btnHoverBackground="#187de4"
                onClick={onSearchDelayed}
              />
              {visibleSearch && (
                <CustomButton
                  className="customClearSearch mr--10"
                  title="Bỏ lọc"
                  btnBgColor="#eceef7"
                  btnColor="#192038"
                  btnHoverBackground="#eceef7"
                  onClick={onClearSearch}
                />
              )}
              <CustomButton
                className="mr--10"
                title="Xuất file"
                btnBgColor="#838d20"
                btnColor="#ffffff"
                btnHoverBackground="#187de4"
                onClick={onExportDelayed}
              />
            </div>
            <div className="d-flex space-between col-12">
              <div className="">
                <span className="b--700">Tổng số: </span>
                {typeApp == "app"
                  ? dataSwapXAU?.total || 0
                  : dataSellXAUTele?.total || 0}
              </div>
              <div className="">
                <span className="b--700">Tổng số XAUT: </span>
                {typeApp == "app"
                  ? `${formatCoinID(totalXAUBuy, 5)}`
                  : `${formatCoinID(totalXAUSell, 5)}`}
              </div>
              <div className="">
                <span className="b--700">Tổng số VNDC: </span>
                {`0 VNDC`}
              </div>
              <div className="">
                <span className="b--700">Tổng số USDT: </span>
                {typeApp == "app" ? `${formatCoinID(totalUSDBuy, 4)}` : `0 USDT`}
              </div>
              <div className="">
                <span className="b--700">Tổng số TON: </span>
                {typeApp == "app" ? `0 TON` : `${formatCoin(totalTONBuy)} TON`}
              </div>
              <div className="">
                <span className="b--700"></span>
              </div>
            </div>

            <Tabs
              defaultActiveKey="1"
              items={[
                {
                  label: "Giao dịch trên App",
                  key: "app",
                  children: <>{listSwapXAUApp()}</>,
                },
                {
                  label: "Giao dịch Mini App",
                  key: "mini_app",
                  children: <>{listSwapXAUTeleApp()}</>,
                },
              ]}
              onChange={(e) => {
                setTypeApp(e);
                e == "app"
                  ? dispatch(
                      actionGetListHistorySwapXAU({
                        page: 1,
                        type: "swap_USDT_XAU",
                      })
                    )
                  : dispatch(
                      actionGetListSellXAUTele({ page: 1, type: "withdrawal" })
                    );
              }}
            />
            {typeApp == "app" ? (
              <div className="mt--20 rowx-center">
                {dataSwapXAU?.paging?.total > dataSwapXAU?.paging?.limit && (
                  <div className="mt--20 rowx-center">
                    <Pagination
                      count={dataSwapXAU?.paging?.count}
                      page={dataSwapXAU?.paging?.page}
                      variant="outlined"
                      shape="rounded"
                      showFirstButton
                      showLastButton
                      onChange={(event, page) => onChangePage(event, page)}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="mt--20 rowx-center">
                {dataSellXAUTele?.paging?.total >
                  dataSellXAUTele?.paging?.limit && (
                  <div className="mt--20 rowx-center">
                    <Pagination
                      count={dataSellXAUTele?.paging?.count} //total
                      page={dataSellXAUTele?.paging?.page} //current page
                      variant="outlined"
                      shape="rounded"
                      showFirstButton
                      showLastButton
                      onChange={(event, page) => onChangePage(event, page)}
                    />
                  </div>
                )}
              </div>
            )}
          </Form>
        </CardBody>
      </Card>
      <Suspense fallback={<div></div>}>
        <section>
          {visibleModalDetail && (
            <DetailSwapXAU
              onCloseModal={closeDetail}
              visibleModal={visibleModalDetail}
              recordModal={recordModal}
              filterModal={filterModal}
            />
          )}
        </section>
      </Suspense>
    </>
  );
}
export default injectIntl(withRouter(ListSellXAU));
